import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Column } from '@ant-design/plots';
import { Button, Row, Col, Form, setParamsFilter, ProTableOt, useProTableOt, DemoProTableOt, message, Modal, Input, RangePicker } from "../../../../../templates/my-app/src/components/ui/ot"
import { useSmartTaskSchedulingTask } from "../pmis/controller/smart_task_scheduling_task_controller";
import { useTranslation } from 'react-i18next';
import TaskModal, { TaskForm } from './smart_task_scheduling_task_modal';
import dayjs from 'dayjs';



const SmartTaskSchedulingTaskTable = ({
    actionRef: propsActionRef,
    edit = true,
    api = `/pmis/smart_task_scheduling/task`,
    onCheckTesk = () => { },
    modalFlag = 0,
    keyPrefix = "pmis.smartTaskSchedulingTask",
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    extraParams,
    customColumns = [],
    customFormItems = () => { },
    extraActionRender,
    toolBarRender = (tools) => ([...tools]),
    propsUseSmartTaskSchedulingTask = useSmartTaskSchedulingTask,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    propsRowKey = "task_id",
    showDefaultColumn = true,
    showDefaultFormItems = [],
    propsModalOpen: modalOpenExternal,
    propsSetModalOpen: setModalOpenExternal,
    propsInitialValues,
    propsForm,
    propsFormReloadCount = 0,
    propsShowKeys = [
        { key: "task_id", name: "task_id", hidden: false, require: false },
        { key: "task_name", name: "task_name", hidden: false, require: false },
        { key: "task_explaination", name: "task_explaination", hidden: false, require: false },
        { key: "person_in_charge", name: "person_in_charge", hidden: false, require: false },
        { key: "executor", name: "executor", hidden: false, require: false },
        { key: "start_time", name: "start_time", hidden: false, require: false },
        { key: "end_time", name: "end_time", hidden: false, require: false },
        { key: "progress", name: "progress", hidden: false, require: false },
        { key: "category_name", name: "category_name", hidden: false, require: false },
        { key: "priority_name", name: "priority_name", hidden: false, require: false },
        { key: "label_name", name: "label_name", hidden: false, require: false },
        { key: "status_name", name: "status_name", hidden: false, require: false },
        { key: "application_submitted_text", name: "application_submitted_text", hidden: false, require: false },
        { key: "create_staff_name", name: "create_staff_name", hidden: false, require: false },
    ],
    propsDefaultAxiosMode,
    postOnBeforeCheck,
    filterMode = "time_start",
    propsFilterCustomColumns = true,
    formMode = false,
    initialValues = {},
    propsSubmit = true,
    propsWidth = 1000,
    propsPost = true,
    showMode,
    showSearch,
    reloadButton,
    manageColumnsButton = true,
    endMessage,
    propsRangeFilter = true,
    propsExport = true,
    propsRowSelection = {},
    cardRender = () => { },
    reorganizeFormData = (value, type) => {
        return [...value];
    },
    cardModeSetting={},
    PropsPatchForm
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const PatchForm = PropsPatchForm ?? <TaskForm
        // propsForm={form}
        propsShowKeys={propsShowKeys}
        keyPrefix={keyPrefix}
        customFormItems={customFormItems}
        formReloadCount={propsFormReloadCount}
        formMode={formMode}

    />
    const defaultColumns = showDefaultColumn ? [
        {
            title: t('index'),
            sorter: true,
            dataIndex: 'key',
            key: 'key',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('task_id'),
            sorter: true,
            dataIndex: 'task_id',
            key: 'task_id',
            //width: "5.5rem",
            canFilter: false,
            filterType: "search",
        },
        {
            title: t('task_name'),
            sorter: true,
            dataIndex: 'task_name',
            key: 'task_name',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => {
                return (
                    <Row>
                        <Col span={12}>
                            {record.task_name}
                        </Col>
                        {dayjs().isAfter(dayjs(record.end_time)) ?
                            <Col span={12} style={{ color: "red" }}>
                                <br />(已逾期)
                            </Col>
                            : <></>}
                    </Row>
                )
            }
        },
        {
            title: t('task_explaination'),
            sorter: true,
            dataIndex: 'task_explaination',
            key: 'task_explaination',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('person_in_charge'),
            sorter: true,
            dataIndex: 'person_in_charge',
            key: 'person_in_charge',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('executor'),
            sorter: true,
            dataIndex: 'executor',
            key: 'executor',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('start_time'),
            sorter: true,
            dataIndex: 'start_time',
            key: 'start_time',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('end_time'),
            sorter: true,
            dataIndex: 'end_time',
            key: 'end_time',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('progress'),
            sorter: true,
            dataIndex: 'progress',
            key: 'progress',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('category_name'),
            sorter: true,
            dataIndex: 'category_name',
            key: 'category_name',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('priority_name'),
            sorter: true,
            dataIndex: 'priority_name',
            key: 'priority_name',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('label_name'),
            sorter: true,
            dataIndex: 'label_name',
            key: 'label_name',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('status_name'),
            sorter: true,
            dataIndex: 'status_name',
            key: 'status_name',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('application_submitted_text'),
            sorter: true,
            dataIndex: 'application_submitted_text',
            key: 'application_submitted_text',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
        {
            title: t('application_submitted_user'),
            sorter: true,
            dataIndex: 'create_staff_name',
            key: 'create_staff_name',
            width: "10rem",
            canFilter: true,
            filterType: "search",
            // copyable: true,
        },
    ] : []
    const columns = [
        ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true && !keyObj.formOnly)),
        ...(propsFilterCustomColumns ? customColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true && !keyObj.formOnly)) : customColumns),
    ]
    const actionRef_ = useRef(null)
    const actionRef = propsActionRef ?? actionRef_
    const [checkTask, setCheckTask] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [extra_columns, set_extra_columns] = useState([]);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[propsRowKey])
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[propsRowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record?.[propsRowKey])
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
                selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
        ...propsRowSelection,
    };

    const [modalOpen_, setModalOpen_] = useState(false)
    const [modalOpen, setModalOpen] = [modalOpenExternal ?? modalOpen_, setModalOpenExternal ?? setModalOpen_]
    const [modalLoading, setModalLoading] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;

    const [rangePickerSearch, setRangePickerSearch] = useState({})

    const handleSubmitRow = (id) => {
        let data = []
        if (id) {
            data = [{
                [propsRowKey]: id
            }]
        }
        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    ...val,
                    [propsRowKey]: val?.[propsRowKey],
                    submit: true,
                    can_edit_status_key: val?.can_edit_status_key || 0,
                    reason_index_ongoing_sop_step_id: val?.reason_index_ongoing_sop_step_id || 0,
                    ...propsInitialValues
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要送出嗎？',
                /* modal內容 */
                onOk: () => {
                    patchSmartTaskSchedulingTaskData(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
                contentStyle: {
                    zindex: 99,
                }
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const onFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error" || status === "failure") {
            /* hook 失敗時回的是 "failure"；後端的 errorInfo 可能是字串或 PDO 的陣列 */
            const errorInfo = values?.errorInfo
            const reason = errorInfo ? `：${typeof errorInfo === 'string' ? errorInfo : JSON.stringify(errorInfo)}` : ''
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error(`修改失敗${reason}`)
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
        // setModalLoading(true)
    }

    const {
        getSmartTaskSchedulingTaskData,
        postSmartTaskSchedulingTaskData,
        patchSmartTaskSchedulingTaskData,
        deleteSmartTaskSchedulingTaskData,
        exportSmartTaskSchedulingTaskData,
        importSmartTaskSchedulingTaskData,
        downloadSmartTaskSchedulingTaskData,
        overSmartTaskSchedulingTaskData,
    } = propsUseSmartTaskSchedulingTask({
        mainApi: api,
        onFinish,
        onBefore,
    });
    const { check, setCheck, checkAll, setOrders, custom_filter_key } = useTableColumnsCheck(columns);
    // const {
    //     check,
    //     setCheck,
    //     checkAll,
    //     setOrders,
    //     custom_filter_key,
    //     transferColumnAntdToShadcn,
    //     transferSortAntdToShadcn
    // } = useProTableOt({
    //     columns
    // })

    useEffect(() => {
        onCheckTesk(checkTask)
    }, [checkTask])
    useEffect(() => {
        checkAll()
    }, [])
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])


    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    headerTitle={<></>}
                    rowKey={propsRowKey}
                    initialValues={propsInitialValues}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...rangePickerSearch,
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword,
                            custom_filter_key: custom_filter_key,
                            ...extraParams,
                            ...filter,
                        }
                        newParams = {
                            ...newParams,
                        }
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        return getSmartTaskSchedulingTaskData({
                            ...newParams
                        })
                    }}
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    scroll={{
                        x: "100vw"
                    }}
                    toolBarRender={() => toolBarRender([
                        ...(propsRangeFilter ? [<RangePicker
                            onValueChange={(value) => {
                                if (value.target.value.length > 0) setRangePickerSearch({
                                    [filterMode + '_start']: value.target.value?.[0],
                                    [filterMode + '_end']: value.target.value?.[1],
                                })
                                else setRangePickerSearch({})
                            }}
                            onChange={(value) => {
                                if (value.target.value.length > 0) setRangePickerSearch({
                                    [filterMode + '_start']: value.target.value?.[0],
                                    [filterMode + '_end']: value.target.value?.[1],
                                })
                                else setRangePickerSearch({})
                            }}
                        />] : []),
                        ...(propsSubmit ? [<Button
                            type={'primary'}
                            onClick={() => handleSubmitRow()}
                        >
                            {t('application_submit')}
                        </Button>] : []),
                        // <Button
                        //     type={'primary'}
                        //     onClick={() => handleAddRow()}
                        // >
                        //     {t('post_task')}
                        // </Button>,
                        // <Button
                        //     variant={"batchDelete"}
                        //     onClick={() => handleDeleteRow()}
                        // >
                        //     {t('delete_multiple')}
                        // </Button>,
                        ...(propsExport ? [
                            <Button className='example' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={e => exportSmartTaskSchedulingTaskData({ 'task_id_arr': selectedRowKeys })}>{t("export")}</Button>
                        ] : []),
                    ])}
                    propsUseData={() => {
                        return {
                            patchData: (data) => {
                                let newValues = reorganizeFormData(data, "submit");
                                return patchSmartTaskSchedulingTaskData(newValues)
                            },
                            postData: (data) => {
                                let newValues = reorganizeFormData(data, "submit");
                                if (postOnBeforeCheck !== undefined) {
                                    if (postOnBeforeCheck(newValues)) {
                                        postSmartTaskSchedulingTaskData(newValues)
                                    }
                                } else {
                                    postSmartTaskSchedulingTaskData(newValues)
                                }
                            },
                            deleteData: deleteSmartTaskSchedulingTaskData,
                        }
                    }}
                    PropsPatchForm={PatchForm}
                    propsPatchonFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}
                    propsPatchOnBefore={() => { }}
                    propsPatch
                    propsPost={manageColumnsButton && propsPost}
                    propsDelete={false}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsPatchProcess={(item) => {
                        return ({
                            ...item,
                            start_time: dayjs(item?.start_time),
                            end_time: dayjs(item?.end_time)
                        })
                    }}
                    propsWidth={propsWidth}
                    propsDefaultAxiosMode={propsDefaultAxiosMode}
                    extraActionRender={(record) => {
                        return <>
                            {extraActionRender && extraActionRender(record)}
                        </>
                    }}
                    formMode={formMode}
                    showMode={showMode}
                    showSearch={showSearch}
                    reloadButton={reloadButton}
                    manageColumnsButton={manageColumnsButton}
                    endMessage={endMessage}
                    cardRender={cardRender}
                    cardModeSetting={cardModeSetting}
                />
            </Col>
        </Row>
    )
}
const SmartTaskSchedulingTask = ({
    propsForm,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    keyPrefix = "pmis.smartTaskSchedulingTask",
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onSelectChange = (selectedRowsInfo) => {
        form.setFieldsValue({ selectedRowsInfo: selectedRowsInfo })
    }
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    onValuesChange={() => { }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name={"selectedRowsInfo"}
                                hidden={true}
                            >
                            </Form.Item>
                            <SmartTaskSchedulingTaskTable
                                defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                                defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                                onSelectChange={onSelectChange}
                                customColumns={[]}
                                extraActionRender={(item) => {
                                    return (<></>)
                                }}
                                toolBarRender={(item) => {
                                    return ([
                                        ...item,
                                        // <Button></Button>
                                    ])
                                }}
                                customFormItems={(fieldName) => {
                                    return (<></>)
                                }}
                                propsRowKey='task_id'
                                formMode
                            // showDefaultColumn={false}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};
export { SmartTaskSchedulingTaskTable }
export default SmartTaskSchedulingTask;
